// extracted by mini-css-extract-plugin
export var bounce = "_o9-1";
export var generatingText = "_o9-6";
export var lightning = "_o9-4";
export var popup = "_o9-5";
export var progressBar = "_o9-7";
export var progressFill = "_o9-8";
export var progressShimmer = "_o9-9";
export var progressText = "_o9-a";
export var shimmer = "_o9-3";
export var uploadIcon = "_o9-0";
export var uploadingText = "_o9-2";